export default {
  path: '/accountManage',
  name: 'accountManage',
  component: () => import('../../views/Layout/index'),
  meta: {
    title: '账户管理',
    // keepAlive: false
  },
  children: [
    {
      // 账户管理
      path: 'accountManageIndex',
      name: 'accountManageIndex',
      component: () => import('../../views/AccountManage/AccountManageIndex'),
      meta: { title: '账户管理', keepAlive: false }
    },
    {
      // 账户管理-管理账户
      path: 'manageAccount',
      name: 'manageAccount',
      // hidden: true,
      component: () => import('../../views/AccountManage/ManageAccount'),
      meta: { title: '管理账户', keepAlive: false }
    }
  ]
}